import { useEffect, useState } from "react";
import { History, ShieldAlert } from "lucide-react";
import { api, fmtDateTime } from "../lib/api";

const COLOR = { dibuat: "bg-sky-500", login: "bg-emerald-500", habis: "bg-amber-500", hangus: "bg-amber-500", hilang: "bg-rose-500", reset: "bg-orange-500", ganti: "bg-fuchsia-500", terjual: "bg-slate-400" };

export function VoucherRiwayat({ code, routerId }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!code) return;
    setD(null);
    api.get(`/vouchers/riwayat/${encodeURIComponent(code)}`, { params: { router_id: routerId || "" } }).then((r) => setD(r.data)).catch(() => setD({ events: [], backup_seen: [], flags: {} }));
  }, [code, routerId]);
  if (!d) return <p className="text-xs text-muted-foreground" data-testid="voucher-riwayat-loading">Memuat riwayat kode…</p>;
  const f = d.flags || {};
  return (
    <div className="rounded-xl border border-border p-3 space-y-2 text-xs" data-testid="voucher-riwayat">
      <div className="flex items-center gap-2 font-semibold text-sm"><History className="w-4 h-4" /> Riwayat Kode (bukti)</div>
      <div className={`rounded-lg px-3 py-2 font-semibold ${f.suspicious ? "bg-rose-500/10 text-rose-400 border border-rose-500/30" : f.login_count ? "bg-emerald-500/10 text-emerald-400 border border-emerald-500/30" : "bg-muted text-muted-foreground"}`} data-testid="voucher-riwayat-verdict">
        {f.suspicious && <ShieldAlert className="w-3.5 h-3.5 inline mr-1 -mt-0.5" />}{f.verdict}
      </div>
      {!d.events.length ? <p className="text-muted-foreground">Tidak ada jejak untuk kode ini di database.</p> : (
        <ol className="space-y-1.5">
          {d.events.map((e, i) => (
            <li key={i} className="flex gap-2" data-testid={`voucher-riwayat-ev-${e.kind}`}>
              <span className={`mt-1 w-2 h-2 rounded-full shrink-0 ${COLOR[e.kind] || "bg-slate-500"}`} />
              <div><span className="font-mono text-muted-foreground">{fmtDateTime(e.at)}</span> — {e.text}{e.by && <span className="text-muted-foreground"> • oleh {e.by}</span>}</div>
            </li>
          ))}
        </ol>
      )}
      {d.backup_seen?.length > 0 && (
        <details className="text-muted-foreground">
          <summary className="cursor-pointer">Terlihat di {d.backup_seen.length} backup harian router (bukti kode pernah ada)</summary>
          <ul className="mt-1 space-y-0.5 font-mono">
            {d.backup_seen.map((b, i) => <li key={i}>{fmtDateTime(b.at)} {b.router} • {b.comment || "-"}{b.disabled === "true" ? " • disabled" : ""}</li>)}
          </ul>
        </details>
      )}
    </div>
  );
}
